<header class="vc-admin-page-header">
  <div class="vc-admin-page-header__main">
    @if (showBack && backLink) {
      <a
        class="vc-admin-page-header__back"
        [routerLink]="backLink"
        [queryParams]="backQueryParams"
        [attr.aria-label]="backLabelKey | translate"
      >
        <i class="fas fa-arrow-left"></i>
        <span>{{ backLabelKey | translate }}</span>
      </a>
    }

    <div class="vc-admin-page-header__meta">
      @if (titleKey) {
        <h2>{{ titleKey | translate }}</h2>
      }

      @if (descriptionKey) {
        <p>{{ descriptionKey | translate }}</p>
      }
    </div>
  </div>

  <div class="vc-admin-page-header__side">
    @if (contextLabelKey && contextValue) {
      <div class="vc-admin-page-header__context">
        <span>{{ contextLabelKey | translate }}</span>
        <strong>{{ contextValue }}</strong>
      </div>
    }

    <div class="vc-admin-page-header__actions">
      <ng-content select="[header-actions]"></ng-content>
    </div>
  </div>
</header>
